import store from "@/vuex";

export default {
    methods:{
        customColorMethod(percentage) {
            if (!percentage) {
                return ''
            }
            if (percentage < 33) {
                return '#f85451';
            } else if (percentage < 66) {
                return '#fb9c2c';
            }else {
                return '#34c30d';
            }
        },
        apiReturnColor(color){
            if(color==1){
                return '#34c30d';
            }else if(color==2){
                return '#fb9c2c';
            }else if(color==3){
                return '#f85451';
            }else{
                return '#f85451';
            }
            // switch (Number(color)) {
            //     case 1:
            //         return '#34c30d';
            //     case 2:
            //         return '#fb9c2c';
            //     case 3:
            //         return '#f85451';
            // }
        },
        //是否为建设单位人角色
        is_constructor(){
            return !!(store.state.user.current_user &&
                store.state.user.current_user.project_zijin_jindu &&
                store.state.user.current_user.project_zijin_jindu.power &&
                store.state.user.current_user.project_zijin_jindu.power.edit != 0);
        },
        //是否为审核人角色
        is_auditor(){
            return !!(store.state.user.current_user &&
                store.state.user.current_user.project_zijin_jindu &&
                store.state.user.current_user.project_zijin_jindu.power &&
                store.state.user.current_user.project_zijin_jindu.power.approve != 0);
        },
        //是否为拨款人角色
        is_payer(){
            return !!(store.state.user.current_user &&
                store.state.user.current_user.project_zijin_jindu &&
                store.state.user.current_user.project_zijin_jindu.power &&
                store.state.user.current_user.project_zijin_jindu.power.allocate != 0);
        },
    }
}